import styled from 'styled-components';

export const StyledMailbox = styled.section`
  ${({ theme }) => theme.mixins.views}
`;

export const StyledMailboxWrapper = styled.div`
  display: flex;
`;
